import { UrlUtils } from '@atlassian/mpac-utils';
export const resolveManagePartnersRoutes = (routePath, parameters) => UrlUtils.resolveUrlFromTemplateAndParameters({
  template: UrlUtils.transformRoutePathToUriTemplate({
    routePath: routePath.split('(\\d+)').join('')
  }),
  parameters
});